// extracted by mini-css-extract-plugin
export var button = "_gv-0";
export var donut = "_gv-1";
export var donutFill = "_gv-3";
export var donutTrack = "_gv-2";